import moment from 'moment';

// Form
import { validators } from 'forms';

// Validators
const { isRequired } = validators;

export const timesheetTimesheetEntryFormValidate = (values: any): any => {
    const errors: any = {};
    const {
        startDate,
        endDate,
        startTime,
        endTime,
        unpaidBreakMinutes,
        workTypeCompositeKey,
        paidBreakMinutes
    } = values;
    errors.startTime = isRequired(startTime);
    errors.endTime = isRequired(endTime);
    errors.workTypeCompositeKey = isRequired(workTypeCompositeKey);

    if (startDate && endDate) {
        const momentStartDate = moment(startDate, 'YYYY-MM-DD');
        const momentEndDate = moment(endDate, 'YYYY-MM-DD');

        if (momentEndDate.isBefore(momentStartDate)) {
            errors.endDate = 'End date must be after the start date';
        }

        if (momentEndDate.diff(momentStartDate, 'days') >= 7) {
            errors.endDate =
                'End date must be less than a week after the start date';
        }
    }

    if (startTime && endTime) {
        const momentStartTime = moment(startTime, 'HH:mm');
        const momentEndTime = moment(endTime, 'HH:mm');
        const unpaidBreakMinutesNumber = unpaidBreakMinutes || 0;
        const paidBreakMinutesNumber = paidBreakMinutes || 0;

        if (
            momentEndTime.diff(momentStartTime, 'minutes') -
                unpaidBreakMinutesNumber -
                paidBreakMinutesNumber <=
            0
        ) {
            errors.endTime =
                'End time must be more than the total breaks after the start time';
        }

        if (momentEndTime.isSameOrBefore(momentStartTime)) {
            errors.endTime = 'End time must be after the start time';
        }
    }
    return errors;
};
